import type { Uuid } from '@shady-pines/types';
import type { Model } from './model';
import type { User } from './user';

export const UserFeatureFlag = ['in_app_chat', 'events'] as const;
export type UserFeatureFlag = (typeof UserFeatureFlag)[number];

export const GlobalFeatureFlag = ['show_site_links', 'events'] as const;
export type GlobalFeatureFlag = (typeof GlobalFeatureFlag)[number];

export const FeatureFlag = [...UserFeatureFlag, ...GlobalFeatureFlag] as const;
export type FeatureFlag = (typeof FeatureFlag)[number];

export type Feature<T extends 'user' | 'global'> = Model<{
  id: Uuid<Feature<T>>;
  user_id: T extends 'user' ? Uuid<User> : null;
  feature: T extends 'user' ? UserFeatureFlag : GlobalFeatureFlag;
  enabled: boolean;
}>;
